import { Building2, KeyRound, HardHat, Handshake } from "lucide-react";

const BTP_IMG = "/images/casque-chantier.jpg";

const SERVICES = [
  { id: "promotion", icon: Building2, title: "Promotion immobilière", text: "Conception et commercialisation de résidences et villas, de l'acquisition du foncier jusqu'à la remise des clés." },
  { id: "location", icon: KeyRound, title: "Location", text: "Mise en location de biens résidentiels et accompagnement des propriétaires comme des locataires." },
  { id: "btp", icon: HardHat, title: "BTP", text: "Travaux de construction et de gros œuvre réalisés avec rigueur, dans le respect des délais et des normes." },
  { id: "prestation", icon: Handshake, title: "Prestation de services", text: "Conseil, suivi de chantier et services sur mesure pour concrétiser votre projet immobilier." },
];

export const Services = () => (
  <section id="services" className="bg-[#1A1716] text-white relative grain scroll-mt-20" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-5 lg:px-10 py-24 md:py-32 grid lg:grid-cols-12 gap-14">
      <div className="lg:col-span-5">
        <p className="eyebrow">Nos métiers</p>
        <h2 className="font-display text-4xl lg:text-5xl mt-4">Un interlocuteur unique, du terrain à la clé</h2>
        <div className="mt-10 aspect-[4/5] max-w-md overflow-hidden rounded-sm">
          <img src={BTP_IMG} alt="Casque de chantier Hélium Résidences" className="h-full w-full object-cover object-center" data-testid="services-image" />
        </div>
      </div>
      <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-white/10 self-start">
        {SERVICES.map(({ id, icon: Icon, title, text }) => (
          <div key={id} className="bg-[#1A1716] p-8 lg:p-10 group hover:bg-[#252120] transition-colors duration-500" data-testid={`service-${id}`}>
            <Icon className="h-8 w-8 text-[#C88A58] transition-transform duration-500 group-hover:-translate-y-1" strokeWidth={1.3} />
            <h3 className="font-display text-2xl mt-8">{title}</h3>
            <p className="text-white/60 text-sm leading-relaxed mt-3">{text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
